import { Component, EventEmitter, Input, Output } from "@angular/core";
import { IndPhrase } from "@shared/models/cat.model";
import { AnchorResult, ReferenceIssue, ReferencePhrase } from "@shared/models/common";
import { RevRule } from "@shared/models/rev.model";
import { CopyAnchorsCoordinatorService } from "@shared/services/copy-anchors-coordinator.service";

@Component({
    selector: 'copy-all-anchors',
    template: `

    <div class="copy-button" *ngIf="copyAnchors">
              <a  class="icon" [class.disabled]="!canCopyAnchors() || disableConsistencyCheckResultsActions" (click)="copyNotExistingAnchors()">
                  
                <i class="fa-regular fa-circle-left" [title]="'translate.general.copyAnchors' | translate" [class.disabled]="!canCopyAnchors() || disableConsistencyCheckResultsActions"></i>
              </a>
    </div>
  `,
    styleUrls: ['./copy-all-anchors.component.scss'],
    standalone: false
} )
export class CopyAllAnchorsComponent {

    @Input() catMatchRefAnchors: AnchorResult[];
    @Input() workingRefAnchors: AnchorResult[];
    @Input() copyAnchors: boolean = false;
    @Input() phrase: IndPhrase | RevRule;
    @Input() isMissingInWorkingPhrase: boolean = false;
    @Input() referenceIssue: ReferenceIssue | null = null;

    @Input() catMatchReference: ReferencePhrase | null = null;

    @Input() disableConsistencyCheckResultsActions = false;
    @Output() copyAllAnchors = new EventEmitter<void>();


    constructor(private copyAnchorsCoordinatorService: CopyAnchorsCoordinatorService) {}


    copyNotExistingAnchors() {
        
            if (this.isMissingInWorkingPhrase && this.catMatchReference != null) {
            
                let workingReference = this.copyAnchorsCoordinatorService.copyReferenceToWorkingPhrase(this.phrase, this.catMatchReference, this.referenceIssue);
                this.workingRefAnchors = workingReference.anchors;

            }
            this.copyAnchorsCoordinatorService.copyNotExistingAnchors(this.workingRefAnchors, this.catMatchRefAnchors, this.phrase);
            this.copyAllAnchors.emit();

    }

    canCopyAnchors() {

        return this.copyAnchorsCoordinatorService.canCopyAnchors(this.workingRefAnchors, this.catMatchRefAnchors);
    }

}